/* ==========================================================================
  home.js only for home page
========================================================================== */

"use strict";

/* global Accordion, $, Splide, home */

/**
 * Remove class on header element if user have scrolled on front page
 */
const scrollHeader = () => {
  const siteHeader = document.querySelector(".site-header");

  if (siteHeader && siteHeader.classList.contains("site-header--front-page")) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 0) {
        siteHeader.classList.remove("site-header--front-page");
      } else {
        siteHeader.classList.add("site-header--front-page");
      }
    });
  }
};

/**
 * Hanle Home FAQ section area, Accordion and Slider
 */
const homeFaqBlock = () => {
  const questionCarouselEl = document.getElementById("question-carousel");
  const homeAccordionEl = document.querySelector(".home-faq__accordion");

  if (!questionCarouselEl || !homeAccordionEl) {
    return;
  }

  const questionSlider = new Splide("#question-carousel", {
    type: "fade",
    arrows: false,
    pagination: false,
    drag: false,
  });

  questionSlider.mount();

  new Accordion(homeAccordionEl, {
    duration: 400,
    showMultiple: false,
    elementClass: "teaser-faq",
    triggerClass: "teaser-faq__header",
    panelClass: "teaser-faq__panel",
    openOnInit: [0],
    onOpen: function (currentElement) {
      // retrieve ID of current element
      const currentElementId = currentElement.getAttribute("id");
      // keep only the digits
      const currentElementIdNumber = currentElementId.replace(/\D/g, "");
      const index = parseInt(currentElementIdNumber);
      // select the corresponding image in the carousel
      questionSlider.go(index);
    },
  });
};

/**
 * Handle Testimonial Slider
 */
const testimonalSlider = () => {
  const testimonalSliderEl = document.getElementById("testimonial-slider");

  if (!testimonalSliderEl) {
    return;
  }

  const testimonalSlider = new Splide("#testimonial-slider", {
    type: "loop",
    arrows: false,
    pagination: true,
    autoplay: true,
    interval: 5000,
    classes: {
      pagination: "splide__pagination splide__pagination--testimonials",
      page: "splide__pagination__page splide__pagination__page--testimonials",
    },
  });

  testimonalSlider.mount();
};

/**
 * Handle mobile presentation slider with legends
 */
const homePresentationSlider = () => {
  const presentationSliderEl = document.getElementById("presentation-slider");

  if (!presentationSliderEl) {
    return;
  }

  const presentationSlider = new Splide("#presentation-slider", {
    type: "fade",
    arrows: false,
    pagination: false,
  });

  const legends = document.getElementsByClassName(
    "presentation-legends__items"
  );
  let current;

  for (let i = 0; i < legends.length; i++) {
    initLegend(legends[i], i);
  }

  function initLegend(legend, index) {
    legend.addEventListener("click", function () {
      presentationSlider.go(index);
    });
  }

  presentationSlider.on("mounted move", function () {
    const legend = legends[presentationSlider.index];

    if (legend) {
      if (current) {
        current.classList.remove("presentation-legends__items--active");
      }

      legend.classList.add("presentation-legends__items--active");
      current = legend;
    }
  });

  presentationSlider.mount();
};

document.addEventListener("DOMContentLoaded", () => {
  homeFaqBlock();
  scrollHeader();
  testimonalSlider();
  homePresentationSlider();
});
